// extracted by mini-css-extract-plugin
export default {"body":"campaignHeader_body__lHCT-","subBody":"campaignHeader_subBody__W69ge"};